<script setup lang="ts">
const props = defineProps({
  dressUpsToTag: {
    type: Array as PropType<
      { text: string; startIndex: number; attributes: any }[]
    >,
    required: true,
  },
});

const documentId = inject("documentId") as any;
const selfAssessmentStore = useDocumentSelfAssessmentStore(documentId);
const { allSteps, stepExpectedInstances } = storeToRefs(selfAssessmentStore);

const dressUpSteps = computed(() => {
  return allSteps.value.filter((step) => {
    return step.validationAttributes?.underline == true;
  });
});

const unclassifiedDressUps = computed(() => {
  return props.dressUpsToTag.filter((dressUp) => {
    return !dressUpSteps.value.some((step) => {
      return dressUp.attributes[step.criteriaAttribute.attribute] != undefined;
    });
  });
});

const categorizedDressUps = computed(() => {
  return dressUpSteps.value.map((step) => {
    const dressUps = props.dressUpsToTag.filter((dressUp) => {
      return dressUp.attributes[step.criteriaAttribute.attribute] != undefined;
    });
    return {
      step,
      dressUps,
    };
  });
});
</script>

<template>
  <div class="flex flex-col gap-6 mb-8 p-4" v-auto-animate>
    <!-- Unclassified Section -->
    <div class="flex flex-col gap-3">
      <h3
        class="text-sm font-semibold text-muted-foreground uppercase tracking-wider"
      >
        Unclassified
      </h3>
      <div
        v-if="unclassifiedDressUps.length > 0"
        class="flex flex-col gap-2"
        v-auto-animate
      >
        <DocumentStudentEditingDressupsSelector
          v-for="word in unclassifiedDressUps"
          :key="word.startIndex"
          :dress-up="word"
        />
      </div>
      <div v-else class="text-sm text-muted-foreground italic pl-2">
        None found
      </div>
    </div>

    <!-- Categorized Sections -->
    <div
      v-for="category in categorizedDressUps"
      :key="category.step.identifier"
      class="flex flex-col gap-3"
    >
      <div class="flex flex-row items-center justify-between" v-auto-animate>
        <h3
          class="text-sm font-semibold text-muted-foreground uppercase tracking-wider"
        >
          {{ category.step.label }}
        </h3>
        <div>
          {{ category.dressUps.length }} /
          {{ stepExpectedInstances(category.step) }}
        </div>
      </div>
      <div
        v-if="category.dressUps.length > 0"
        class="flex flex-col gap-2"
        v-auto-animate
      >
        <DocumentStudentEditingDressupsSelector
          v-for="word in category.dressUps"
          :key="word.startIndex"
          :dress-up="word"
        />
      </div>
      <div v-else class="text-sm text-muted-foreground italic pl-2">
        None found
      </div>
    </div>
  </div>
</template>

<style scoped></style>
